import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IClone } from "src/@types/clones";
import {
  getFavoritesAsync,
  removeFromFavoritesAsync,
} from "./actions";
import { FavoritesState } from "./slice";

type ActionReducerMapBuilderWithFavoritesState =
  ActionReducerMapBuilder<FavoritesState>;

export const getFavoritesReducer = (
  builder: ActionReducerMapBuilderWithFavoritesState,
) => {
  builder.addCase(getFavoritesAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getFavoritesAsync.fulfilled,
    (state, action: PayloadAction<IResponseWithPagination<IClone>>) => {
      state.isLoading = false;
      state.data = action.payload;
    }
  );

  builder.addCase(getFavoritesAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = null
  });
}

export const removeFromFavoritesReducer = (
  builder: ActionReducerMapBuilderWithFavoritesState,
) => {
  builder.addCase(removeFromFavoritesAsync.fulfilled,
    (state, action: PayloadAction<number>) => {
      const deletedCloneId = action.payload;

      // CHANGE
      if (state.data && state.data.results) {
        state.data.results = state.data.results.filter(
          ({ id }) => deletedCloneId !== id
        );
      }
    }
  );
}